export const sqlQuestions = [
    // Basic SQL
    {
        id: 1,
        category: 'Basic SQL',
        difficulty: 'Easy',
        question: 'Which SQL statement is used to extract data from a database?',
        options: [
            'SELECT',
            'GET',
            'OPEN',
            'EXTRACT'
        ],
        correct: 0,
        explanation: 'SELECT is the fundamental command to specific attributes and tables to retrieve data.'
    },
    {
        id: 2,
        category: 'Basic SQL',
        difficulty: 'Easy',
        question: 'Which keyword is used to return only distinct (different) values?',
        options: [
            'DISTINCT',
            'UNIQUE',
            'DIFFERENT',
            'COUNT'
        ],
        correct: 0,
        explanation: 'SELECT DISTINCT column_name; removes duplicates from the result set.'
    },
    {
        id: 3,
        category: 'Basic SQL',
        difficulty: 'Easy',
        question: 'Which SQL keyword is used to sort the result-set?',
        options: [
            'ORDER BY',
            'SORT BY',
            'ARRANGE BY',
            'GROUP BY'
        ],
        correct: 0,
        explanation: 'ORDER BY sorts the records in ascending or descending order.'
    },

    // Joins
    {
        id: 4,
        category: 'Joins',
        difficulty: 'Medium',
        question: 'Which JOIN returns records that have matching values in both tables?',
        options: [
            'INNER JOIN',
            'LEFT JOIN',
            'RIGHT JOIN',
            'FULL JOIN'
        ],
        correct: 0,
        explanation: 'INNER JOIN selects records that have matching values in both tables.'
    },
    {
        id: 5,
        category: 'Joins',
        difficulty: 'Medium',
        question: 'Which JOIN returns all records from the left table, and the matched records from the right table?',
        options: [
            'LEFT JOIN',
            'INNER JOIN',
            'RIGHT JOIN',
            'CROSS JOIN'
        ],
        correct: 0,
        explanation: 'LEFT JOIN returns all records from the left table (table1), and the matched records from the right table (table2). The result is NULL from the right side, if there is no match.'
    },
    {
        id: 6,
        category: 'Joins',
        difficulty: 'Medium',
        question: 'What is the result of a CROSS JOIN?',
        options: [
            'Cartesian product of both tables',
            'Only matching rows',
            'All rows from both tables combined',
            'An error'
        ],
        correct: 0,
        explanation: 'CROSS JOIN returns the Cartesian product (all possible combinations) of rows from both tables.'
    },

    // Aggregation & Grouping
    {
        id: 7,
        category: 'Aggregation',
        difficulty: 'Medium',
        question: 'Which clause is used to filter groups based on an aggregate function?',
        options: [
            'HAVING',
            'WHERE',
            'GROUP BY',
            'FILTER'
        ],
        correct: 0,
        explanation: 'WHERE cannot be used with aggregate functions; HAVING was added to SQL for this purpose.'
    },
    {
        id: 8,
        category: 'Aggregation',
        difficulty: 'Easy',
        question: 'Which function returns the number of rows that match a specified criterion?',
        options: [
            'COUNT()',
            'SUM()',
            'AVG()',
            'MAX()'
        ],
        correct: 0,
        explanation: 'COUNT(*) returns the number of records in a table.'
    },

    // Database Design & Keys
    {
        id: 9,
        category: 'Database Design',
        difficulty: 'Easy',
        question: 'What is a Primary Key?',
        options: [
            'A column (or set of columns) that uniquely identifies each row in a table',
            'A key used to encrypt the database',
            'The first column in a table',
            'A key that allows duplicates'
        ],
        correct: 0,
        explanation: 'A Primary Key must contain unique values and cannot contain NULL values.'
    },
    {
        id: 10,
        category: 'Database Design',
        difficulty: 'Easy',
        question: 'What is a Foreign Key?',
        options: [
            'A field (or collection of fields) in one table that refers to the PRIMARY KEY in another table',
            'A key from another country',
            'A backup key',
            'A key that effectively creates a clone'
        ],
        correct: 0,
        explanation: 'Foreign Keys are used to enforce referential integrity between tables.'
    },
    {
        id: 11,
        category: 'Normalization',
        difficulty: 'Medium',
        question: 'What is the main goal of Normalization?',
        options: [
            'To reduce data redundancy and improve data integrity',
            'To make queries faster',
            'To increase database size',
            'To create more tables'
        ],
        correct: 0,
        explanation: 'Normalization organizes columns and tables to minimize redundancy and dependency.'
    },
    {
        id: 12,
        category: 'Normalization',
        difficulty: 'Hard',
        question: 'What is required for 2nd Normal Form (2NF)?',
        options: [
            'It must be in 1NF and have no partial dependency',
            'It must be in 1NF and have no transitive dependency',
            'It must be in 3NF',
            'It must have a composite key'
        ],
        correct: 0,
        explanation: '2NF removes subsets of data that apply to multiple rows of a table and places them in separate tables found via relationships (no partial dependency).'
    },
    {
        id: 13,
        category: 'Normalization',
        difficulty: 'Hard',
        question: 'What classifies 3rd Normal Form (3NF)?',
        options: [
            'It is in 2NF and has no transitive dependencies',
            'It is in 2NF and has no partial dependencies',
            'It has no duplicate rows',
            'It has no NULL values'
        ],
        correct: 0,
        explanation: '3NF requires that all non-key columns are dependent on the key, the whole key, and nothing but the key.'
    },

    // Indexes & Performance
    {
        id: 14,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is a Clustered Index?',
        options: [
            'It determines the physical order of data in a table',
            'It is a separate structure from the data table',
            'It creates a copy of the table',
            'It allows duplicates'
        ],
        correct: 0,
        explanation: 'A Clustered Index sorts and stores the data rows in the table or view based on their key values. There can be only one per table.'
    },
    {
        id: 15,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is a Non-Clustered Index?',
        options: [
            'A structure separate from the data rows, containing the key value and a pointer to the data row',
            'The physical order of the table',
            'A primary key',
            'A backup table'
        ],
        correct: 0,
        explanation: 'Non-Clustered Indexes are like an index in a book. The data is stored in one place, the index in another.'
    },
    {
        id: 16,
        category: 'Performance',
        difficulty: 'Hard',
        question: 'What does "SARGable" mean?',
        options: [
            'Search ARGument ABLE: query predicates that can take advantage of an index',
            'Search Argument Global: a global search setting',
            'Sortable Argument: columns that can be sorted',
            'Select All Rows Grouped'
        ],
        correct: 0,
        explanation: 'SARGable queries allow the query optimizer to use indexes efficiently (e.g., usually avoiding functions on columns in WHERE clauses).'
    },

    // Transactions
    {
        id: 17,
        category: 'Transactions',
        difficulty: 'Medium',
        question: 'What does ACID stand for in database transactions?',
        options: [
            'Atomicity, Consistency, Isolation, Durability',
            'Accuracy, Consistency, Isolation, Database',
            'Atomicity, Control, Integration, Durability',
            'Access, Common, Interaction, Data'
        ],
        correct: 0,
        explanation: 'ACID properties guarantee that database transactions are processed reliably.'
    },
    {
        id: 18,
        category: 'Transactions',
        difficulty: 'Medium',
        question: 'Which transaction isolation level prevents "Dirty Reads"?',
        options: [
            'Read Committed (or higher)',
            'Read Uncommitted',
            'Snapshot',
            'Serializable'
        ],
        correct: 0,
        explanation: 'Read Uncommitted allows dirty reads. Read Committed guarantees that any data read is committed at the moment it is read.'
    },

    // T-SQL High Level
    {
        id: 19,
        category: 'T-SQL',
        difficulty: 'Medium',
        question: 'What is the difference between DELETE and TRUNCATE?',
        options: [
            'DELETE is a DML command that can have a WHERE clause; TRUNCATE is a DDL command that resets the table identity and is faster',
            'DELETE is faster than TRUNCATE',
            'TRUNCATE can be rolled back, DELETE cannot',
            'There is no difference'
        ],
        correct: 0,
        explanation: 'TRUNCATE removes all rows by deallocating pages (less log overhead) and resets identity seeds. DELETE removes rows one by one and logs each delete.'
    },
    {
        id: 20,
        category: 'T-SQL',
        difficulty: 'Medium',
        question: 'What is the difference between UNION and UNION ALL?',
        options: [
            'UNION removes duplicate records; UNION ALL includes duplicates',
            'UNION ALL is slower',
            'UNION only works on numbers',
            'UNION ALL sorts the results'
        ],
        correct: 0,
        explanation: 'UNION processes the combined set to remove duplicates (expensive sort/hash), while UNION ALL simply concatenates the sets.'
    },
    {
        id: 21,
        category: 'T-SQL',
        difficulty: 'Medium',
        question: 'What is a Stored Procedure?',
        options: [
            'A prepared SQL code that you can save, so the code can be reused over and over again',
            'A temporary table',
            'A view',
            'A backup script'
        ],
        correct: 0,
        explanation: 'Stored Procedures allow encapsulation of logic, security (permissions), and performance benefits (plan caching).'
    },
    {
        id: 22,
        category: 'T-SQL',
        difficulty: 'Medium',
        question: 'What is a View?',
        options: [
            'A virtual table based on the result-set of an SQL statement',
            'A physical copy of a table',
            'A user interface screen',
            'A stored procedure'
        ],
        correct: 0,
        explanation: 'Views simplify complex queries, provide extra security (row/column level), and present data in a specific perspective.'
    },
    {
        id: 23,
        category: 'T-SQL',
        difficulty: 'Hard',
        question: 'What is a CTE (Common Table Expression)?',
        options: [
            'A temporary named result set that you can reference within a SELECT, INSERT, UPDATE, or DELETE statement',
            'A generic table',
            'A variable type',
            'A loop structure'
        ],
        correct: 0,
        explanation: 'CTEs (WITH clause) make complex queries more readable and allow recursion.'
    },
    {
        id: 24,
        category: 'T-SQL',
        difficulty: 'Hard',
        question: 'What is a Trigger?',
        options: [
            'A special kind of stored procedure that automatically executes when an event occurs in the database server',
            'A button in the UI',
            'A scheduled job',
            'A constraint'
        ],
        correct: 0,
        explanation: 'Triggers run in response to DML events (INSERT, UPDATE, DELETE) or DDL events, often used for auditing or enforcing complex rules.'
    },

    // Advanced
    {
        id: 25,
        category: 'Advanced',
        difficulty: 'Hard',
        question: 'What is "SQL Injection"?',
        options: [
            'A code injection technique where malicious SQL statements are inserted into an entry field for execution',
            'A way to load data faster',
            'A database upgrade',
            'A type of join'
        ],
        correct: 0,
        explanation: 'Prevent SQL injection by using parameterized queries or stored procedures.'
    },
    {
        id: 26,
        category: 'Advanced',
        difficulty: 'Hard',
        question: 'What is the purpose of the EXPLAIN or EXPLAIN PLAN statement?',
        options: [
            'To display the execution plan that the query optimizer chooses for a SELECT statement',
            'To verify the syntax',
            'To backup the query',
            'To run the query in debug mode'
        ],
        correct: 0,
        explanation: 'Execution plans help diagnose performance issues by showing how the database engine retrieves the data (indexes used, join algorithms, etc.).'
    },
    {
        id: 27,
        category: 'Advanced',
        difficulty: 'Hard',
        question: 'What is a "Deadlock"?',
        options: [
            'A situation where two or more transactions are waiting for one another to give up locks',
            'A slow query',
            'A crashed server',
            'A permission error'
        ],
        correct: 0,
        explanation: 'Deadlocks must be resolved by the database engine (killing one victim) or prevented via careful access patterns.'
    },
    {
        id: 28,
        category: 'Advanced',
        difficulty: 'Easy',
        question: 'Which SQL constraint ensures that all values in a column are different?',
        options: [
            'UNIQUE',
            'NOT NULL',
            'CHECK',
            'DEFAULT'
        ],
        correct: 0,
        explanation: 'The UNIQUE constraint ensures that all values in a column are distinct.'
    },
    {
        id: 29,
        category: 'Advanced',
        difficulty: 'Easy',
        question: 'What is the default sort order for ORDER BY?',
        options: [
            'ASC (Ascending)',
            'DESC (Descending)',
            'Random',
            'None'
        ],
        correct: 0,
        explanation: 'If not specified, ORDER BY defaults to Ascending (ASC).'
    },
    {
        id: 30,
        category: 'Advanced',
        difficulty: 'Medium',
        question: 'What does the LIKE operator do?',
        options: [
            'It is used in a WHERE clause to search for a specified pattern in a column',
            'It compares numbers',
            'It joins tables',
            'It creates a copy'
        ],
        correct: 0,
        explanation: 'LIKE uses wildcards (% and _) to match string patterns.'
    },
    {
        id: 31,
        category: 'Advanced',
        difficulty: 'Medium',
        question: 'What is the purpose of the GROUP BY statement?',
        options: [
            'To group rows that have the same values into summary rows, usually with aggregate functions',
            'To sort rows',
            'To hiding rows',
            'To join rows'
        ],
        correct: 0,
        explanation: 'GROUP BY is essential for generating reports (e.g., "Sales per Region").'
    },

    // Window Functions
    {
        id: 32,
        category: 'Window Functions',
        difficulty: 'Hard',
        question: 'What is the difference between RANK() and DENSE_RANK()?',
        options: [
            'RANK() skips the next ranking for ties (1, 1, 3); DENSE_RANK() does not skip (1, 1, 2)',
            'They are identical',
            'DENSE_RANK() skips numbers',
            'RANK() is deprecated'
        ],
        correct: 0,
        explanation: 'If two people tie for 1st place, RANK() gives both 1, and the next person 3. DENSE_RANK() gives the next person 2.'
    },
    {
        id: 33,
        category: 'Window Functions',
        difficulty: 'Hard',
        question: 'What does ROW_NUMBER() do?',
        options: [
            'Assigns a unique sequential integer to rows within a partition, starting at 1',
            'Counts the rows',
            'Randomizes rows',
            'Returns the row ID'
        ],
        correct: 0,
        explanation: 'ROW_NUMBER() is useful for pagination or removing duplicates (e.g., "DELETE WHERE RowNum > 1").'
    },
    {
        id: 34,
        category: 'Window Functions',
        difficulty: 'Medium',
        question: 'What is the PARTITION BY clause used for?',
        options: [
            'To divide the result set into partitions to which the window function is applied',
            'To create physical partitions on disk',
            'To split tables',
            'To filter data'
        ],
        correct: 0,
        explanation: 'PARTITION BY acts like a "local Group By" for the window function, resetting the calculation for each group (e.g., Running Total per Customer).'
    },

    // Advanced CTE & T-SQL
    {
        id: 35,
        category: 'T-SQL',
        difficulty: 'Hard',
        question: 'What is a Recursive CTE used for?',
        options: [
            'Traversing hierarchical data (like an org chart or folder structure)',
            'Looping infinitely',
            'Simple calculations',
            'Creating temporary tables'
        ],
        correct: 0,
        explanation: 'Recursive CTEs reference themselves, allowing iteration over hierarchical data until a termination condition is met.'
    },
    {
        id: 36,
        category: 'T-SQL',
        difficulty: 'Medium',
        question: 'What is the difference between VARCHAR and NVARCHAR?',
        options: [
            'NVARCHAR stores Unicode characters (2 bytes per char); VARCHAR stores non-Unicode (1 byte)',
            'VARCHAR is for variable length; NVARCHAR is for numbers',
            'NVARCHAR is deprecated',
            'There is no difference'
        ],
        correct: 0,
        explanation: 'Use NVARCHAR if you need to support international characters (Chinese, Arabic, etc.). It takes double the storage space.'
    },
    {
        id: 37,
        category: 'T-SQL',
        difficulty: 'Medium',
        question: 'What is the MERGE statement?',
        options: [
            'It performs Insert, Update, or Delete operations on a target table based on the results of a join with a source table',
            'It joins two tables',
            'It combines two databases',
            'It locks the table'
        ],
        correct: 0,
        explanation: 'MERGE (Upsert) is efficient for synchronizing two tables in a single statement.'
    },

    // Indexing Internals
    {
        id: 38,
        category: 'Performance',
        difficulty: 'Hard',
        question: 'What is a "Heap" in SQL Server?',
        options: [
            'A table without a clustered index',
            'A pile of data',
            'The memory pool',
            'A fast table'
        ],
        correct: 0,
        explanation: 'Data in a Heap is stored in no particular order. Retrieving data usually requires a Table Scan (slow for large data).'
    },
    {
        id: 39,
        category: 'Performance',
        difficulty: 'Hard',
        question: 'What is an "Index Seek" vs "Index Scan"?',
        options: [
            'Seek moves directly to the data (fast); Scan reads the entire index (slower)',
            'Scan is faster than Seek',
            'Seek is deprecated',
            'They are the same'
        ],
        correct: 0,
        explanation: 'Index Seek uses the B-Tree structure to find rows efficiently. Index Scan reads every row in the index leaf level.'
    },
    {
        id: 40,
        category: 'Performance',
        difficulty: 'Hard',
        question: 'What is "Fill Factor"?',
        options: [
            'A percentage value that determines how full the leaf-level pages of an index should be during creation',
            'How full the database is',
            'A compression setting',
            'The speed of the query'
        ],
        correct: 0,
        explanation: 'Lowering Fill Factor leaves free space on pages, reducing Page Splits during inserts/updates, but increases storage/memory usage.'
    },

    // Isolation Levels & Locking
    {
        id: 41,
        category: 'Transactions',
        difficulty: 'Hard',
        question: 'What is a "Phantom Read"?',
        options: [
            'When a query returns a set of rows, and a subsequent execution returns a different set of rows (due to inserts/deletes by another transaction)',
            'Reading ghost data',
            'Reading uncommitted data',
            'A database error'
        ],
        correct: 0,
        explanation: 'Phantom Reads occur when the focus is on a range of rows. "Serializable" isolation level prevents this.'
    },
    {
        id: 42,
        category: 'Transactions',
        difficulty: 'Hard',
        question: 'What is the "Serializable" Isolation Level?',
        options: [
            'The highest level; transactions are completely isolated (locks ranges), preventing Dirty, Non-Repeatable, and Phantom reads',
            'The default level',
            'A level that allows no concurrency',
            'The fastest level'
        ],
        correct: 0,
        explanation: 'Serializable offers the highest consistency but lowest concurrency due to aggressive locking.'
    },

    // Modern SQL Features
    {
        id: 43,
        category: 'Modern SQL',
        difficulty: 'Medium',
        question: 'What is JSON support in SQL Server used for?',
        options: [
            'Parsing, storing, and querying JSON data using functions like JSON_VALUE and OPENJSON',
            'Converting the database to NoSQL',
            'Running JavaScript',
            'Web styling'
        ],
        correct: 0,
        explanation: 'It allows integrating relation data with NoSQL workloads, storing flexible attributes without changing schema.'
    },
    {
        id: 44,
        category: 'Modern SQL',
        difficulty: 'Medium',
        question: 'What is a "Temporal Table" (System-Versioned)?',
        options: [
            'A table that automatically keeps history of data changes, allowing "time travel" queries',
            'A temporary table',
            'A table for dates',
            'A scheduler'
        ],
        correct: 0,
        explanation: 'Temporal Tables allow you to query data "AS OF" a specific point in time, great for auditing and forensics.'
    },

    // Constraints & Keys
    {
        id: 45,
        category: 'Database Design',
        difficulty: 'Medium',
        question: 'What is a Composite Key?',
        options: [
            'A primary key composed of multiple columns',
            'A foreign key',
            'A super key',
            'A secret key'
        ],
        correct: 0,
        explanation: 'Used when a single column is not sufficient to uniquely identify a row (e.g., OrderID + ProductID).'
    },
    {
        id: 46,
        category: 'Database Design',
        difficulty: 'Medium',
        question: 'What is Cascade Delete?',
        options: [
            'When a parent row is deleted, all related child rows are automatically deleted',
            'It prevents deletion',
            'It errors on deletion',
            'It archives the data'
        ],
        correct: 0,
        explanation: 'Cascade Delete maintains referential integrity but can be dangerous if large amounts of data are accidentally wiped.'
    },

    // Functions
    {
        id: 47,
        category: 'T-SQL',
        difficulty: 'Medium',
        question: 'What is the difference between a Scalar Function and a Table-Valued Function?',
        options: [
            'Scalar returns a single value; Table-Valued returns a table result set',
            'Scalar is faster',
            'TVF is deprecated',
            'No difference'
        ],
        correct: 0,
        explanation: 'Inline Table-Valued Functions are generally more performant than Multi-Statement TVFs or Scalar functions.'
    },
    {
        id: 48,
        category: 'T-SQL',
        difficulty: 'Easy',
        question: 'What does COALESCE() do?',
        options: [
            'Returns the first non-null value in a list',
            'Combines strings',
            'Calculates average',
            'Finds the max value'
        ],
        correct: 0,
        explanation: 'COALESCE(val1, val2, \'Default\') is powerful for handling NULLs in display logic.'
    },

    // Security & Admin
    {
        id: 49,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What is Row-Level Security (RLS)?',
        options: [
            'A feature to restrict access to rows based on user characteristics (e.g., UserID)',
            'Encryption of rows',
            'Hiding columns',
            'Password protection'
        ],
        correct: 0,
        explanation: 'RLS allows multi-tenant applications to share a single database while ensuring tenants only see their own data.'
    },
    {
        id: 50,
        category: 'Performance',
        difficulty: 'Hard',
        question: 'What is Parameter Sniffing?',
        options: [
            'When SQL Server compiles a plan based on the parameter values of the first execution, which might not be optimal for subsequent runs',
            'A security hack',
            'Identifying slow queries',
            'Sniffing network traffic'
        ],
        correct: 0,
        explanation: 'It can cause inconsistent performance. Solutions include OPTION (RECOMPILE) or optimizing code for uniform distribution.'
    }
];
